export const largeMuffinPan = {
  recipes: [
    {
      id: 'Morning Glory Muffins',
      link: 'https://pamperedchef.widen.net/view/thumbnail/rgyglioejk/post-recipe-morning-glory-muffins-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/rgyglioejk/jpeg/post-recipe-morning-glory-muffins-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-morning-glory-muffins-steps.jpg',
      },
    },
    {
      id: 'Burrito Cups',
      link: 'https://pamperedchef.widen.net/view/thumbnail/fwooyczpd5/post-recipe-burrito-cups-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/fwooyczpd5/jpeg/post-recipe-burrito-cups-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-burrito-cups-steps.jpg',
      },
    },
  ],
};
